module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSuccess) ? _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": "icon",
      "title": _vm.name
    }
  }) : _c('span', {
    attrs: {
      "title": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6e0f020!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/IconHeaderComponent.vue
// module id = 1347
// module chunks = 2